import React from "react";
import { GpdBody } from "components/views/gpd//GpdBody";
import { GpdHeader } from "components/views/gpd/GpdHeader";
import { FullscreenView } from "components/utils/FullscreenView";
import { edstFontDim } from "@poscon/shared-frontend";

export const Gpd = () => <FullscreenView view="GPD" HeaderComponent={GpdHeader} BodyComponent={GpdBody} minWidth={edstFontDim.width * 74} />;
